export const getQueryString = queryObject => {
  const queryString = Object.entries(queryObject)
    .map(([name, value]) => (value ? `${name}=${value}` : ""))
    .filter(item => !!item)
    .toString()
    .replaceAll(",", "&");
  return queryString ? `?${queryString}` : "";
};
